import type { Producto as Product } from "@/types";
import { all_category_products } from "./products/index";

type Category = { id: string; nombre: string; color: string };

export const defaultProducts: Product[] = all_category_products;

export const defaultCategories: Category[] = [
  { id: "cat_beb", nombre: "Bebidas", color: "bg-sky-500" },
  { id: "cat_car", nombre: "Carnes", color: "bg-amber-500" },
  { id: "cat_gra", nombre: "Granos", color: "bg-yellow-500" },
  { id: "cat_lac", nombre: "Lácteos", color: "bg-blue-300" },
  { id: "cat_fv", nombre: "Frutas y Verduras", color: "bg-green-500" },
  { id: "cat_pan", nombre: "Panadería", color: "bg-amber-200" },
  { id: "cat_aseo", nombre: "Aseo", color: "bg-green-600" },
  { id: "cat_snk", nombre: "Snacks", color: "bg-orange-400" },
  { id: "cat_fast", nombre: "Comida Rápida", color: "bg-red-500" },
  { id: "cat_rest", nombre: "Almuerzo", color: "bg-emerald-600" },
  { id: "cat_desay", nombre: "Desayuno", color: "bg-orange-400" },
  { id: "cat_extra", nombre: "Extras", color: "bg-violet-500" },
  { id: "cat_vet", nombre: "Veterinaria", color: "bg-teal-500" },
  { id: "cat_ropa", nombre: "Ropa y Moda", color: "bg-indigo-500" },
  { id: "cat_calz", nombre: "Calzado", color: "bg-amber-700" },
  { id: "cat_acc", nombre: "Accesorios", color: "bg-slate-600" },
  { id: "cat_tech", nombre: "Tecnología", color: "bg-violet-600" },
  { id: "cat_hogar", nombre: "Hogar", color: "bg-rose-400" },
  { id: "cat_salsa", nombre: "Salsas y Condimentos", color: "bg-orange-500" },
  { id: "cat_farm", nombre: "Farmacia / Salud", color: "bg-blue-600" },
  { id: "cat_ferr", nombre: "Ferretería", color: "bg-gray-600" },
  { id: "cat_jug", nombre: "Juguetería", color: "bg-yellow-400" },
  { id: "cat_pap", nombre: "Papelería y Oficina", color: "bg-indigo-300" },
  { id: "cat_dep", nombre: "Deportes y Fitness", color: "bg-red-600" },
  {
    id: "cat_bell",
    nombre: "Belleza y Cuidado Personal",
    color: "bg-pink-400",
  },
  { id: "cat_masc", nombre: "Mascotas", color: "bg-green-400" },
  { id: "cat_joy", nombre: "Joyería y Accesorios", color: "bg-yellow-300" },
  { id: "cat_flor", nombre: "Floristería", color: "bg-fuchsia-400" },
  { id: "cat_serv", nombre: "Servicios", color: "bg-cyan-500" },
  { id: "cat_auto", nombre: "Automotriz", color: "bg-gray-700" },
  { id: "cat_mue", nombre: "Muebles y Decoración", color: "bg-stone-400" },
  { id: "cat_mini", nombre: "Tienda de Conveniencia", color: "bg-amber-600" },
  { id: "cat_hela", nombre: "Heladería y Postres", color: "bg-amber-300" },
  { id: "cat_pesce", nombre: "Pescados y Mariscos", color: "bg-blue-400" },
  { id: "cat_elec", nombre: "Electrónica", color: "bg-violet-500" },
  { id: "cat_lib", nombre: "Librería", color: "bg-orange-600" },
];
